export default {
    name: 'tên',
    tel: 'Điện thoại',
    save: 'Cứu',
    clear: 'Thông thoáng',
    cancel: 'Hủy bỏ',
    confirm: 'Xác nhận',
    delete: 'Xóa',
    loading: 'Đang tải ...',
    telEmpty: 'Vui lòng nhập số điện thoại',
    nameEmpty: 'Vui lòng điền vào tên',
    nameInvalid: 'Tên không hợp lệ',
    confirmDelete: 'Bạn có chắc chắn muốn xóa không?',
    telInvalid: 'Số điện thoại không đúng định dạng',
    vanCalendar: {
      end: 'Kết thúc',
      start: 'Bắt ​​đầu',
      title: 'Lịch',
      startEnd: 'Bắt đầu/Kết thúc',
      weekdays: [
        'chủ nhật',
        'thứ hai',
        'thứ ba',
        'Thứ Tư',
        'Thứ năm',
        'Thứ sáu',
        'thứ bảy',
      ],
      monthTitle: (year, month) => `${year}/${month}`,
      rangePrompt: (maxRange) => `Chọn không quá ${maxRange} ngày`,
    },
    vanCascader: {
      select: 'Chọn',
    },
    vanContactCard: {
        addText: 'Thêm liên hệ'
    },
    vanContactList: {
        addText: 'Thêm liên hệ mới'
    },
    vanPagination: {
      prev: 'Trước đó',
      next: 'Tiếp theo',
    },
    vanPullRefresh: {
      pulling: 'Kéo để làm mới ...',
      loosing: 'Loose để làm mới ...',
    },
    vanSubmitBar: {
      label: 'Tổng:',
    },
    vanCoupon: {
      unlimited: 'Không giới hạn',
      discount: (discount) => `Chiết khấu ${discount * 10}%`,
      condition: (condition) => `Ít nhất ${condition}`,
    },
    vanCouponCell: {
      title: 'Phiếu giảm giá',
      tips: 'Không có phiếu ưu đãi',
      count: (count) => `Bạn có ${count} phiếu giảm giá`,
    },
    vanCouponList: {
      empty: 'Không có phiếu ưu đãi‌',
      exchange: 'Trao đổi',
      close: 'Đóng',
      enable: 'Có sẵn',
      disabled: 'Không khả dụng',
      placeholder: 'Mã phiếu thưởng',
    },
    vanAddressEdit: {
      area: 'Khu vực',
      postal: 'mã bưu điện',
      areaEmpty: 'Vui lòng chọn khu vực nhận hàng',
      addressEmpty: 'Địa chỉ không được để trống',
      postalEmpty: 'mã bưu điện sai',
      defaultAddress: 'Đặt làm địa chỉ mặc định',
      telPlaceholder: 'điện thoại',
      namePlaceholder: 'tên',
      areaPlaceholder: 'khu vực'
    },
    vanAddressEditDetail: {
      label: 'địa chỉ',
      placeholder: 'địa chỉ'
    },
    vanAddressList: {
      add: 'Thêm địa chỉ mới',
    },
  };